/* eslint-disable no-template-curly-in-string */
export default {
  HRready: 'HRready',
  'Conversation 自测': 'Conversation 自我測試',
  页面未找到: '找不到頁面',
  地推登录: '地推登入',
  地推人员不存在: '地推人員不存在',
  地推邀请码: '地推邀請碼',
  地推业绩: '地推成效',
  招聘者审核详情: '招募者審核詳情',
  用户审核: '使用者審核',
  'HRready Invitation': 'HRready 邀請',
  'Campaign rules': '活動細則',
  'HRready User Agreement': 'HRready 使用者協議',
  'Privacy Policy': '隱私政策',
  'AI & Automated Services Notice': 'AI 與自動化服務通知',
  'Communications & AI Calls Policy': '通訊與 AI 通話政策',
  'California Privacy Notice': '加州隱私聲明',
  'Campaign rules | HRready': '活動細則 | HRready',
  'Legal Documents | HRready': '法律文件 | HRready',
  'Privacy Policy | HRready': '隱私政策 | HRready',
  'HRready User Agreement | HRready': 'HRready 使用者協議 | HRready',
  'AI & Automated Services Notice | HRready': 'AI 與自動化服務通知 | HRready',
  'Communications & AI Calls Policy | HRready': '通訊與 AI 通話政策 | HRready',
  'California Privacy Notice | HRready': '加州隱私聲明 | HRready',
  下拉刷新: '下拉重新整理',
  释放立即刷新: '放開立即重新整理',
  刷新成功: '重新整理成功',
  '${name} invited you': '${name} 邀請了你',
  'Your AI job assistant, always ready': '你的 AI 求職助手，隨時準備就緒',
  'Free to register': '免費註冊',
  'Always-on matching': '持續配對',
  'You stay in control': '你始終掌控全局',
  'Referral rewards': '推薦獎勵',
  '${amount} EACH': '每人 ${amount}',
  'UP TO ${amount}': '最高 ${amount}',
  '${amount} cash reward for each qualified new job seeker sign-up.':
    '每位符合資格的新求職者註冊後，可獲得 ${amount} 現金獎勵。',
  'AI job assistant': 'AI 求職助理',
  'Your search keeps moving': '讓你的求職持續推進',
  "The person who invited you can't see your phone number, work history, or applications.":
    '邀請你的人無法查看你的手機號碼、工作經歷或求職申請。',
  'Register free and start searching': '免費註冊並開始搜尋',
  'In as little as ${hours} hours': '最快 ${hours} 小時內',
  '${hours}h': '${hours} 小時',
  'Refer ${count}, get': '推薦 ${count} 人，可得',
  '${amount} per hour': '每小時 ${amount}',
  'in ${hours}h.': '最快 ${hours} 小時。',
  'Paid after registration, verification, and eligibility review. No reward for non-genuine job-search sign-ups, duplicate accounts, or suspicious activity.':
    '完成註冊、驗證和資格審核後發放。非真實求職註冊、重複帳號或可疑活動不予獎勵。',
  'Start in about ${seconds} seconds': '約 ${seconds} 秒即可開始',
  'Create your HRready account': '建立你的 HRready 帳號',
  'Close registration': '關閉註冊',
  'Invitation relationship connected': '邀請關係已關聯',
  'Registration successful': '註冊成功',
  'Your account is connected to this invitation. Eligibility and rewards are determined by platform review records.':
    '你的帳戶已關聯本次邀請，後續資格與獎勵以平台審核記錄為準。',
  'Registration completed normally without an invitation relationship.': '本次已按一般註冊完成，未建立邀請關係。',
  'US mobile number': '美國手機號碼',
  'Enter your mobile number': '請輸入手機號碼',
  'Verification code': '驗證碼',
  'Enter the verification code': '請輸入驗證碼',
  'Enter code': '輸入驗證碼',
  'Send code': '傳送驗證碼',
  'Resend in ${countdown}s': '${countdown}s 後重新傳送',
  'Please accept the agreements': '請勾選協議',
  'Failed to load the agreements. Please try again later.': '協議載入失敗，請稍後再試',
  'Failed to send the code. Please try again later.': '驗證碼傳送失敗，請稍後再試',
  'Verification code sent': '驗證碼已傳送',
  'Send a verification code first': '請先傳送驗證碼',
  'Better jobs, closer to home': '更好的工作，離家更近',
  YOUR: '你的',
  'NEXT PAYCHECK': '下一份薪水',
  'IS CLOSER': '近在眼前',
  'THAN YOU THINK.': '比你想像中更近。',
  'Up to': '最高可達',
  'per hour': '每小時',
  'Get hired in': '最快入職',
  'Close to home': '離家近',
  'walk to work': '步行上班',
  'HRready — your AI job-search assistant.': 'HRready——你的 AI 求職助理。',
  'REGISTER NOW': '立即註冊',
  'Get hired': '快速入職',
  'Jobs close to home': '離家近的工作',
  'Find nearby work that fits your schedule': '尋找符合你時間安排的附近工作',
  'Earn more': '賺得更多',
  'Discover better-paying hourly jobs': '發現薪資更高的時薪工作',
  'Fast matching': '快速配對',
  'Apply once, keep matching': '一次申請，持續配對',
  'Tell us what you want. AI keeps searching.': '告訴我們你的需求，AI 會持續搜尋。',
  'Communicate for you': '代你溝通',
  'Make phone calls and organize information to reduce repetitive filling out and confirmation processes.':
    '撥打電話並整理資訊，減少重複填寫和確認流程。',
  'Promotion process': '推進流程',
  'Submit job applications, contact candidates, and follow up on interview progress.':
    '提交職位申請、聯絡候選人並追蹤面試進度。',
  "I'll contact you when I need it.": '需要時再聯絡你',
  'When confirmation or authorization is required, HRready will remind you to proceed.':
    '需要確認或授權時，HRready 會提醒你繼續操作。',
  'When confirmation or authorization is required, a card will remind you to proceed.':
    '需要確認或授權時，卡片會提醒你繼續操作。',
  'Open HRready': '開啟 HRready',
  'Open the app and let AI understand your goals.': '開啟應用程式，讓 AI 了解你的目標。',
  'Open the web version or download the app, and select "Find a job" or "Recruit someone".':
    '開啟網頁版或下載應用程式，選擇「找工作」或「招募」。',
  'Answer AI calls': '接聽 AI 電話',
  'Clearly state the opportunities and preferences.': '清楚說明機會和偏好。',
  'Clearly state the requirements and key conditions.': '清楚說明需求和關鍵條件。',
  'View progress': '查看進度',
  'Track your applications, interviews, and next steps.': '追蹤申請、面試和後續步驟。',
  'Confirm the application, candidates, and interview arrangements.': '確認申請、候選人和面試安排。',
  'JOB HUNTING\nOR HIRING.\nLEAVE IT TO HRREADY.': '找工作\n或招募。\n交給 HRREADY。',
  'AI Job Search and Recruitment Assistant': 'AI 求職與招募助理',
  'iOS Download': 'iOS 下載',
  'Android Download': 'Android 下載',
  'What will HRready\ndo for you?': 'HRready 能為你做什麼？',
  'Three steps to begin': '三步開始',
  'Delegate repetitive tasks to HRready, and make the key decisions yourself.':
    '把重複任務交給 HRready，關鍵決定由你完成。',
  'Every step is recorded and can be viewed or taken over at any time.': '每一步都有記錄，可隨時查看或接管。',
  'Download APP': '下載 APP',
  地推助手: '地推助手',
  上午好: '早安',
  工作中: '工作中',
  已暂停: '已暫停',
  入职中: '入職中',
  邀请码: '邀請碼',
  业绩: '業績',
  退出: '登出',
  登录: '登入',
  登录地推工作台: '登入地推工作台',
  登录方式: '登入方式',
  '登录已失效，正在返回登录页': '登入已失效，正在返回登入頁面',
  '登录中...': '登入中...',
  发送中: '傳送中',
  工作邮箱: '工作電子郵件',
  欢迎回来: '歡迎回來',
  获取验证码: '取得驗證碼',
  记住登录状态: '記住登入狀態',
  密码: '密碼',
  密码登录: '密碼登入',
  密码登录账号类型: '密碼登入帳號類型',
  '密码通过加密连接提交，平台不会展示密码': '密碼會透過加密連線傳送，平台不會顯示密碼',
  '请输入 4 位验证码': '請輸入 4 位驗證碼',
  请输入密码: '請輸入密碼',
  请输入手机号: '請輸入手機號碼',
  请输入邮箱: '請輸入電子郵件',
  请输入正确的邮箱: '請輸入有效的電子郵件',
  '请输入至少 8 位密码': '請輸入至少 8 個字元的密碼',
  请先获取验证码: '請先取得驗證碼',
  使用手机号或邮箱密码登录: '使用手機號碼或電子郵件密碼登入',
  使用手机号验证码快速登录: '使用手機號碼驗證碼快速登入',
  手机号: '手機號碼',
  显示密码: '顯示密碼',
  验证码登录: '驗證碼登入',
  验证码仅发送至已开通的地推手机号: '驗證碼只會傳送至已開通地推權限的手機號碼',
  邮箱: '電子郵件',
  隐藏密码: '隱藏密碼',
  账号安全保护: '帳號安全保護',
  账号或密码错误: '帳號或密碼錯誤',
  验证码: '驗證碼',
  请输入验证码: '請輸入驗證碼',
  '验证码发送失败，请稍后重试': '驗證碼傳送失敗，請稍後再試',
  验证码不正确或已失效: '驗證碼不正確或已失效',
  '登录状态确认失败，请重试': '無法確認登入狀態，請再試一次',
  重新加载: '重新載入',
  二维码: 'QR 碼',
  '二维码包含你的 HRready 地推邀请链接': 'QR 碼包含你的 HRready 地推邀請連結',
  分享邀请码或二维码: '分享邀請碼或 QR 碼',
  复制邀请码: '複製邀請碼',
  后续进度在业绩页查看: '後續進度可在業績頁面查看',
  让新用户在注册时填写此邀请码: '請新使用者在註冊時填寫此邀請碼',
  扫码使用我的邀请码: '掃碼使用我的邀請碼',
  推广码展示方式: '推廣碼顯示方式',
  完成注册验证: '完成註冊驗證',
  我的推广码: '我的推廣碼',
  '向新用户展示邀请码或二维码，注册时即可关联你的推广来源。':
    '向新使用者顯示邀請碼或 QR 碼，註冊時即可連結至你的推廣來源。',
  新用户注册并通过验证: '新使用者註冊並通過驗證',
  邀请更多用户加入: '邀請更多使用者加入',
  邀请码加载中: '邀請碼載入中',
  邀请码已复制: '邀請碼已複製',
  '邀请码用于提出来源归因，最终业绩以平台验证记录为准。': '邀請碼用於提出來源歸因，最終業績以平台驗證記錄為準。',
  展示推广码: '顯示推廣碼',
  '注册、匹配、面试和结算进度，一部手机随时查看。': '註冊、配對、面試和結算進度，隨時都能用手機查看。',
  计入业绩进展: '計入業績進度',
  随时掌握你的: '隨時掌握你的',
  'MY PROMOTION CODE': '我的推廣碼',
  推广码加载失败: '推廣碼載入失敗',
  '请检查网络后重试，当前未切换为手工邀请码。': '請檢查網路後重試，目前未切換為手動邀請碼。',
  完成普通邀请: '完成一般邀請',
  '当前无活动推广码，不承诺计入活动业绩': '目前沒有活動推廣碼，不承諾計入活動業績',
  '${count} 条': '${count} 筆',
  '${value}年': '${value}年',
  '${value}月': '${value}月',
  '${value}日': '${value}日',
  '查看全部 ${count} 条': '查看全部 ${count} 筆',
  '查看邀请用户从注册到面试的进度，以及对应结算金额。': '查看受邀使用者從註冊到面試的進度，以及對應的結算金額。',
  从注册到确认面试: '從註冊到確認面試',
  待结算: '待結算',
  待结算收入: '待結算收入',
  '待结算收入加载失败，请稍后重试': '待結算收入載入失敗，請稍後再試',
  待结算收入加载中: '待結算收入載入中',
  待支付: '待支付',
  当前日期范围内暂无待结算收入: '目前日期範圍內沒有待結算收入',
  归属招聘者: '歸屬招募者',
  加载中: '載入中',
  取消: '取消',
  结束日期: '結束日期',
  结算概览: '結算概覽',
  结算收入与财务回传实时汇总: '即時彙總結算收入與財務回傳結果',
  '结算数据加载失败，请稍后重试': '結算資料載入失敗，請稍後再試',
  结算数据加载中: '結算資料載入中',
  开始日期: '開始日期',
  可参与匹配: '可參與配對',
  累计业绩金额: '累計業績金額',
  默认最近七天: '預設最近七天',
  全部来源: '全部來源',
  确认: '確認',
  确认面试: '確認面試',
  收起: '收合',
  '数据截至 ${date}': '資料截至 ${date}',
  数据来自结算收入事实与财务付款结果: '資料來自結算收入記錄與財務付款結果',
  实时快照: '即時快照',
  我的业绩: '我的業績',
  下一页: '下一頁',
  验证注册: '驗證註冊',
  业绩概览: '業績概覽',
  业绩区间: '業績區間',
  '业绩数据加载失败，请稍后重试': '業績資料載入失敗，請稍後再試',
  业务时区: '業務時區',
  已支付累计: '累計已支付',
  '预计解冻 ${date}': '預計於 ${date} 解凍',
  至: '至',
  注册时间: '註冊時間',
  转化进度: '轉化進度',
  总金额: '總金額',
  最近进展: '最近進度',
  '操作未完成，请检查网络后重试': '操作未完成，請檢查網路後再試',
  创建审核: '建立審核',
  待补充: '待補充',
  待审核: '待審核',
  当前账号没有招聘者审核权限: '目前帳號沒有招募者審核權限',
  地推邀请: '地推邀請',
  该招聘者已不在你的当前归属范围内: '該招募者已不在你目前的歸屬範圍內',
  企业: '企業',
  企业信息待完善: '企業資訊待完善',
  全部状态: '全部狀態',
  审核: '審核',
  审核不通过: '審核未通過',
  '审核不通过 · 待补充': '審核未通過 · 待補充',
  '审核服务或附件存储暂不可用，请稍后重试': '審核服務或附件儲存空間暫時無法使用，請稍後再試',
  审核通过: '審核通過',
  审核状态: '審核狀態',
  市场: '市場',
  市场待完善: '市場資訊待完善',
  '提交内容不符合要求，请检查后重试': '提交的內容不符合要求，請檢查後再試',
  提交审核: '提交審核',
  退回补充: '退回補充',
  未分配: '未分配',
  未提供: '未提供',
  邀请: '邀請',
  用户来源: '使用者來源',
  资料完善: '資料完善',
  '资料保存、提交和审核决定分别记录，审核只针对已提交版本。':
    '資料儲存、提交和審核決定會分別記錄，審核只針對已提交的版本。',
  资料待上传: '資料待上傳',
  '资料已被更新，请刷新后重新操作': '資料已更新，請重新整理後再操作',
  资料已提交审核: '資料已提交審核',
  自然流量: '自然流量',
  返回用户列表: '返回使用者列表',
  重试: '再試一次',
  '第 ${page} / ${totalPages} 页 · 共 ${total} 人': '第 ${page} / ${totalPages} 頁 · 共 ${total} 人',
  查看资料: '查看資料',
  '仅展示当前归属招聘者，改派后原负责人立即失去访问权限': '只顯示目前歸屬的招募者，改派後原負責人會立即失去存取權限',
  没有符合筛选条件的招聘者: '沒有符合篩選條件的招募者',
  审核用户分页: '審核使用者分頁',
  '审核用户加载失败，请检查网络后重试': '審核使用者載入失敗，請檢查網路後再試',
  搜索招聘者: '搜尋招募者',
  上一页: '上一頁',
  完善资料: '完善資料',
  '姓名、用户 ID、手机号、企业或市场': '姓名、使用者 ID、手機號碼、企業或市場',
  用户审核筛选: '使用者審核篩選',
  招聘者详情: '招募者詳情',
  '正在加载审核用户...': '正在載入審核使用者...',
  状态待确认: '狀態待確認',
  保存并提交审核: '儲存並提交審核',
  保存资料: '儲存資料',
  必填: '必填',
  补充说明: '補充說明',
  补充资料要求: '補充資料要求',
  查看审核资料: '查看審核資料',
  当前版本附件: '目前版本附件',
  当前归属: '目前歸屬',
  '附件不能超过 10 MB': '附件不可超過 10 MB',
  '附件上传失败，请检查文件后重试': '附件上傳失敗，請檢查檔案後再試',
  '附件下载失败，请稍后重试': '附件下載失敗，請稍後再試',
  '附件已上传，请保存资料以关联到当前版本': '附件已上傳，請儲存資料以關聯至目前版本',
  '每个资料版本最多关联 10 个附件': '每個資料版本最多可關聯 10 個附件',
  '仅支持 PDF、JPG 和 PNG 文件': '僅支援 PDF、JPG 和 PNG 檔案',
  审核版本: '審核版本',
  审核不通过时必填: '審核未通過時必填',
  '审核不通过原因 / 补充要求': '審核未通過原因 / 補充要求',
  '审核决定固定使用已提交版本，不能在本区编辑或替换资料。': '審核決定固定使用已提交版本，無法在此區編輯或替換資料。',
  审核已通过: '審核已通過',
  审核招聘者资料: '審核招募者資料',
  '审核状态不修改职位状态，仅作为候选端可见性和自动匹配的资格依据。':
    '審核狀態不會變更職缺狀態，僅作為候選端可見性和自動配對的資格依據。',
  审核资料: '審核資料',
  审核资料已保存: '審核資料已儲存',
  刷新资料: '重新整理資料',
  上传附件: '上傳附件',
  '上传中...': '上傳中...',
  填写并上传资料: '填寫並上傳資料',
  '下载 ${filename}': '下載 ${filename}',
  '移除 ${filename}': '移除 ${filename}',
  已提交资料: '已提交資料',
  已退回补充资料: '已退回補充資料',
  用户基础信息: '使用者基本資訊',
  暂未关联附件: '尚未關聯附件',
  暂无审核记录: '尚無審核記錄',
  招聘者审核资料: '招募者審核資料',
  '招聘者审核资料加载失败，请检查网络后重试': '招募者審核資料載入失敗，請檢查網路後再試',
  正在加载招聘者资料: '正在載入招募者資料',
  '支持 PDF、JPG、PNG，单个不超过 10 MB': '支援 PDF、JPG、PNG，單一檔案不超過 10 MB',
  只读审核依据: '唯讀審核依據',
  '注册于 ${date}': '註冊於 ${date}',
  资料: '資料',
  资料版本与审核记录: '資料版本與審核記錄',
  资料编号: '資料編號',
  资料名称: '資料名稱',
  资料语言: '資料語言',
  最近更新: '最近更新',
  最新资料版本: '最新資料版本',
};
